export default __webpack_public_path__ + "static/media/goldBadge.fd23aee4.svg";